const en: Record<string, string> = {
  // App
  'app.title': 'Admin Portal',
  'app.loading': 'Loading...',

  // Login
  'login.title': 'Admin Portal',
  'login.subtitle': 'Administrator Login',
  'login.username': 'Username',
  'login.username_placeholder': 'Enter username',
  'login.password': 'Password',
  'login.password_placeholder': 'Enter password',
  'login.submit': 'Login',
  'login.loading': 'Logging in...',
  'login.network_error': 'Network error, please try again',

  // Navigation
  'nav.dashboard': 'Dashboard',
  'nav.users': 'User Management',
  'nav.spaces': 'Space Management',
  'nav.reports': 'Report Management',
  'nav.platform_config': 'Platform Settings',
  'nav.admin_management': 'Sub-accounts',
  'nav.audit_logs': 'Audit Logs',

  // Layout
  'layout.admin': 'Admin',
  'layout.logout': 'Logout',

  // Language
  'lang.zh': '中文',
  'lang.en': 'English',
  'lang.switch': 'Switch Language',

  // Common
  'common.loading': 'Loading...',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.clear_all_filters': 'Clear',
  'common.confirm': 'Confirm',
  'common.apply': 'Apply',
  'common.close': 'Close',
  'common.warning': 'Warning',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.create': 'Create',
  'common.update': 'Update',
  'common.search': 'Search',
  'common.all': 'All',
  'common.active': 'Active',
  'common.inactive': 'Inactive',
  'common.enabled': 'Enabled',
  'common.disabled': 'Disabled',
  'common.status': 'Status',
  'common.actions': 'Actions',
  'common.show_less': 'Show less',
  'common.show_more_media': 'Show {count} more images',
  'common.name': 'Name',
  'common.description': 'Description',
  'common.username': 'Username',
  'common.display_name': 'Display Name',
  'common.password': 'Password',
  'common.email': 'Email',
  'common.role': 'Role',
  'common.created_at': 'Created At',
  'common.saving': 'Saving...',
  'common.save_success': 'Saved successfully',
  'common.save_failed': 'Failed to save',
  'common.create_failed': 'Failed to create',
  'common.update_failed': 'Failed to update',
  'common.operation_failed': 'Operation failed',
  'common.no_data': 'No data',
  'common.prev_page': 'Previous',
  'common.next_page': 'Next',
  'common.page_info': 'Page {page} / {totalPages}',
  'common.vs_last_month': 'vs last month',
  'common.public': 'Public',
  'common.private': 'Private',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.copied': 'Copied',
  'common.copy': 'Copy',
  'common.upload': 'Upload',
  'common.uploading': 'Uploading...',
  'common.remove': 'Remove',
  'common.generating': 'Generating...',
  'common.generate_new_link': 'Generate New Link',
  'common.save_changes': 'Save Changes',
  'common.optional': 'optional',
  'common.view_image': 'View image',
  'common.view_avatar': 'View avatar',
  'common.view_member_detail': 'View member details',
  'common.view_room_detail': 'View room details',

  // Dashboard
  'dashboard.title': 'Dashboard',
  'dashboard.welcome': 'Welcome back, here is your platform overview',
  'dashboard.total_users': 'Total Users',
  'dashboard.active_rooms': 'Active Rooms',
  'dashboard.pending_reports': 'Pending Reports',
  'dashboard.today_messages': 'Today Messages',
  'dashboard.rebuild_stats': 'Refresh Stats',
  'dashboard.rebuilding': 'Refreshing...',
  'dashboard.user_growth': 'User Growth Trend',
  'dashboard.weekly_activity': 'Weekly Activity',
  'dashboard.recent_activity': 'Recent Activity',
  'dashboard.new_registration': 'New Registration',
  'dashboard.new_registration_desc':
    '{count} new users registered in the past hour',
  'dashboard.new_registration_desc_dynamic':
    '{count} new user(s) in the last 24h. Latest: {name}',
  'dashboard.new_report': 'New Report',
  'dashboard.new_report_desc':
    'Inappropriate content reported in a public room',
  'dashboard.new_report_desc_dynamic':
    '{count} new report(s). Latest in room "{room}"',
  'dashboard.hot_room': 'Trending Room',
  'dashboard.hot_room_desc': 'A room has exceeded 100K messages',
  'dashboard.hot_room_desc_dynamic': '"{room}" has {count} messages today',
  'dashboard.user_banned': 'User Banned',
  'dashboard.user_banned_desc': 'Admin banned 3 violating accounts',
  'dashboard.user_banned_desc_dynamic':
    '{count} user(s) banned in the last 24h',
  'dashboard.5min_ago': '5 min ago',
  'dashboard.12min_ago': '12 min ago',
  'dashboard.1hour_ago': '1 hour ago',
  'dashboard.2hours_ago': '2 hours ago',
  'dashboard.just_now': 'Just now',
  'dashboard.min_ago': 'min ago',
  'dashboard.hours_ago': 'hour(s) ago',
  'dashboard.mon': 'Mon',
  'dashboard.tue': 'Tue',
  'dashboard.wed': 'Wed',
  'dashboard.thu': 'Thu',
  'dashboard.fri': 'Fri',
  'dashboard.sat': 'Sat',
  'dashboard.sun': 'Sun',
  'dashboard.month': '{n}',
  'dashboard.user_count': 'Users',
  'dashboard.message_count': 'Messages',
  'dashboard.no_recent_activity': 'No recent activity',
  'dashboard.activity.new_registration': 'New Registration',
  'dashboard.activity.new_registration_desc':
    '{count} new user(s) registered in the past hour',
  'dashboard.activity.new_report': 'New Report',
  'dashboard.activity.new_report_desc':
    '{count} new report(s) in the past 24 hours',
  'dashboard.activity.trending_room': 'Trending Room',
  'dashboard.activity.trending_room_desc': '"{name}" has active messages today',
  'dashboard.activity.user_banned': 'User Banned',
  'dashboard.activity.user_banned_desc':
    'Admin banned {count} violating account(s)',

  // User Management
  'users.title': 'User Management',
  'users.subtitle': 'Manage all platform user accounts',
  'users.add_user': 'Add User',
  'users.total_users': 'Total Users',
  'users.active_users': 'Active Users',
  'users.banned': 'Banned',
  'users.new_today': 'New Today',
  'users.search_placeholder': 'Search username...',
  'users.user': 'User',
  'users.join_date': 'Join Date',
  'users.phone_number': 'Phone Number',
  'users.email': 'Email',
  'users.rooms_joined': 'Rooms Joined',
  'users.groups': 'Groups',
  'users.message_count': 'Messages',
  'users.rooms_count': '{count} rooms',
  'users.messages_count': '{count} messages',
  'users.view_detail': 'View Detail',
  'users.send_notification': 'Send Notification',
  'users.view_groups': 'View Groups',
  'users.ban_user': 'Ban User',
  'users.unban_user': 'Unban User',
  'users.delete_account': 'Delete Account',
  'users.edit_user': 'Edit User',
  'users.create_user': 'Add New User',
  'users.create_user_desc': 'Create a new user account',
  'users.username_placeholder': 'Enter username...',
  'users.display_name_placeholder': 'Enter display name...',
  'users.mobile_placeholder': 'Enter mobile number...',
  'users.password_placeholder': 'Enter password...',
  'users.mobile_number': 'Mobile Number',
  'users.password_keep': 'Password (leave blank to keep)',
  'users.back_to_list': 'Back to User List',
  'users.member': 'Member',
  'users.space_owner': 'Space Owner',
  'users.space_admin': 'Space Admin',
  'users.user_info': 'User Info',
  'users.location': 'Location',
  'users.last_active': 'Last Active',
  'users.user_role': 'User Role',
  'users.rooms_participated': 'Rooms Participated',
  'users.activity_log': 'Activity Log',
  'users.no_rooms': 'No room data',
  'users.no_activity': 'No activity records',
  'users.report_history': 'Report History',
  'users.reported_for': 'Reported - {type}',
  'users.report_in_room': 'Reported in room "{room}"',
  'users.no_reports': 'No report records',
  'users.friends': 'Friends',
  'users.blocked': 'Blocked',
  'users.no_friends': 'No friends',
  'users.view_chat': 'View chat',
  'users.no_blocks': 'No blocked users',
  'users.report_status_pending': 'Pending',
  'users.report_status_reviewing': 'Reviewing',
  'users.report_status_resolved': 'Resolved',
  'users.report_status_rejected': 'Rejected',
  'users.group_room': 'Group Room',
  'users.direct_message': 'Direct Message',
  'users.group_roles': 'Group Roles',
  'users.role_member': 'Member',
  'users.role_owner': 'Space Owner',
  'users.role_admin': 'Room Admin',
  'users.user_list': 'User List',

  'users.daily_avg_messages': 'Daily Avg Messages',
  'users.total_logins': 'Total Logins',
  'users.delete_title': 'Delete Account',
  'users.delete_confirm':
    "This action is irreversible. Confirm deleting user {name}'s account?",
  'users.delete_warning': 'Warning',
  'users.delete_warning_text':
    'Deleting the account will permanently remove all user data, including messages, group memberships, etc. This cannot be undone.',
  'users.confirm_delete': 'Confirm Delete',
  'users.delete_blocked_space_owner': 'This user owns a space',
  'users.delete_blocked_space_owner_text':
    'A space cannot be left without an owner. Transfer ownership of their spaces to another member first, then delete the account.',
  'users.ban_title': 'Ban User',
  'users.ban_confirm': 'Confirm banning user {name}?',
  'users.ban_reason': 'Ban Reason',
  'users.ban_reason_placeholder': 'Enter ban reason...',
  'users.confirm_ban': 'Confirm Ban',
  'users.ban_warning_title': 'Warning',
  'users.ban_warning':
    'After banning, this user will not be able to log in or use the platform. This action can be reversed in User Management.',
  'users.mute_user': 'Mute User',
  'users.unmute_user': 'Unmute User',
  'users.mute_title': 'Mute User',
  'users.mute_confirm':
    'Confirm muting user {name}? They will not be able to send messages.',
  'users.mute_reason': 'Mute Reason',
  'users.mute_reason_placeholder': 'Enter mute reason...',
  'users.mute_duration': 'Mute Duration',
  'users.mute_indefinite': 'Indefinite',
  'users.mute_1_hour': '1 Hour',
  'users.mute_24_hours': '24 Hours',
  'users.mute_7_days': '7 Days',
  'users.mute_30_days': '30 Days',
  'users.mute_custom': 'Custom',
  'users.confirm_mute': 'Confirm Mute',
  'users.mute_warning_title': 'Mute User',
  'users.mute_warning':
    'After muting, the user will not be able to send any messages or images on the platform.',
  'users.muted': 'Muted',
  'users.muted_until': 'Muted until {date}',
  'users.muted_indefinitely': 'Muted indefinitely',
  'users.user_rooms': 'User Rooms',
  'users.user_rooms_desc': 'All rooms {name} participates in',
  'users.members': 'members',
  'users.notify_title': 'Send Notification',
  'users.notify_desc': 'Send system notification to {name}',
  'users.notify_subject': 'Title',
  'users.notify_subject_placeholder': 'Notification title',
  'users.notify_content': 'Content',
  'users.notify_content_placeholder': 'Notification content...',
  'users.sending': 'Sending...',
  'users.bio': 'Focused on tech exchange and project collaboration',

  // Space Management
  'spaces.title': 'Space Management',
  'spaces.subtitle': 'Manage spaces and their rooms',
  'spaces.add_space': 'Add Space',
  'spaces.total_spaces': 'Total Spaces',
  'spaces.space_members': 'Space Members',
  'spaces.room_count': 'Rooms',
  'spaces.today_messages': 'Today Messages',
  'spaces.search_placeholder': 'Search space name or owner...',
  'spaces.space_name': 'Space Name',
  'spaces.space_owner': 'Space Owner',
  'spaces.member_count': 'Members',
  'spaces.rooms': 'Rooms',
  'spaces.rooms_count': '{count} rooms',
  'spaces.type': 'Type',
  'spaces.type_public': 'Public',
  'spaces.type_private': 'Private',
  'spaces.back_to_list': 'Back to Space List',
  'spaces.reported': 'Deactivated',
  'spaces.owner_label': 'Owner:',
  'spaces.created_at': 'Created on {date}',
  'spaces.edit_info': 'Edit Info',
  'spaces.transfer_ownership': 'Transfer Ownership',
  'spaces.manage_admins': 'Manage Admins',
  'spaces.add_room': 'Add Room',
  'spaces.add_member': 'Add Member',
  'spaces.add_member_title': 'Add Space Members',
  'spaces.add_member_desc': 'Search and add users to group "{name}"',
  'spaces.select_users': 'Search Users',
  'spaces.select_user_placeholder': 'Search by username or display name...',
  'spaces.no_members_selected': 'Search and select users to add above',
  'spaces.confirm_add_members': 'Add {count} Member(s)',
  'spaces.total_messages': 'Total Messages',
  'spaces.active_rooms': 'Active Rooms',
  'spaces.member_list_title': 'Member List',
  'spaces.total_count': '{count} members total',
  'spaces.total_member_count': 'Total Members',
  'spaces.admin_count': 'Admins',
  'spaces.active_member_count': 'Active Members',
  'spaces.space_created_date': 'Created Date',
  'spaces.back_to_detail': 'Back to Space Detail',
  'spaces.search_member_placeholder': 'Search member name, username ID...',
  'spaces.filter_all_members': 'All Members',
  'spaces.filter_admins': 'Admins',
  'spaces.filter_members': 'Members',
  'spaces.member_name': 'Member',
  'spaces.join_date': 'Join Date',
  'spaces.last_active': 'Last Active',
  'spaces.role_owner': 'Owner',
  'spaces.role_admin': 'Admin',
  'spaces.role_member': 'Member',
  'spaces.view_space_members': 'View Members',

  // Member actions
  'members.view_user_detail': 'View User Detail',
  'members.set_admin': 'Set as Admin',
  'members.remove_admin': 'Remove Admin',
  'members.remove_member': 'Remove Member',
  'members.confirm_set_admin': 'Set {name} as admin?',
  'members.confirm_remove_admin': 'Remove {name} from admin role?',
  'members.confirm_remove_member':
    'Remove {name} from this group? This action cannot be undone.',
  'spaces.search_rooms': 'Search room name or admin...',
  'spaces.room_name': 'Room Name',
  'spaces.admin': 'Admin',
  'spaces.message_count': 'Messages',
  'spaces.view_detail': 'View Detail',
  'spaces.assign_admin': 'Assign Admin',
  'spaces.view_members': 'View Members',
  'spaces.delete_space': 'Delete Group',
  'spaces.confirm_delete_space':
    'Are you sure you want to delete group "{name}"? This action cannot be undone.',
  'spaces.toggle_status_title': 'Confirm Action',
  'spaces.toggle_status_confirm':
    'Are you sure you want to {action} group "{name}"?',
  'spaces.mute_room': 'Mute Room',
  'spaces.delete_room': 'Delete Room',
  'spaces.no_rooms': 'No rooms',
  'spaces.view': 'View',
  'spaces.deactivate': 'Deactivate',
  'spaces.activate': 'Activate',
  'spaces.create_space': 'Add New Group',
  'spaces.name_required': 'Group Name',
  'spaces.space_name_placeholder': 'Enter group name',
  'spaces.name_must_be_unique': 'Must be unique',
  'spaces.space_desc_placeholder': 'Enter group description',
  'spaces.description_label': 'Group Description',
  'spaces.visibility': 'Space Type',
  'spaces.visibility_private_desc': 'Requires invitation link or code to join',
  'spaces.visibility_public_desc':
    'Visible to all users, can view all public rooms',
  'spaces.select_visibility': 'Select visibility',
  'spaces.join_rule': 'Join Rule',
  'spaces.select_join_rule': 'Select join rule',
  'spaces.join_open': 'Open',
  'spaces.join_invite_only': 'Invite Only',
  'spaces.join_invitation_code': 'Invitation Code',
  'spaces.join_approval': 'Requires Approval',
  'spaces.join_not_set': 'Not Set',
  'spaces.select_owner': 'Select owner',
  'spaces.owner_must_select_existing': 'Must select from any existing users',
  'spaces.search_users': 'Search users...',

  // Space Detail
  'spaces.edit_space_title': 'Edit Space Info',
  'spaces.edit_space': 'Edit Group',
  'spaces.edit_space_desc': 'Modify the basic info and settings of the group',
  'spaces.create_space_desc':
    'Create a new group. The group owner can create multiple rooms within the group.',
  'spaces.save_changes': 'Save Changes',
  'spaces.rules': 'Rules',
  'spaces.rules_placeholder': 'Space rules...',
  'spaces.category': 'Category',
  'spaces.no_category': 'No category',
  'spaces.transfer_title': 'Transfer Space Ownership',
  'spaces.transfer_desc': 'Assign a new owner for {name}',
  'spaces.current_owner': 'Current Owner',
  'spaces.select_new_owner': 'Select New Owner',
  'spaces.select_from_owners': 'Select from space owners',
  'spaces.select_from_members': 'Select from space admins',
  'spaces.transfer_admin_only_hint':
    'Ownership can only be transferred to a current space admin. Promote the member to admin first if they are not listed.',
  'spaces.transfer_note':
    'After transfer, the new owner will have full management permissions',
  'spaces.transfer_notice_title': 'Important Notice',
  'spaces.transfer_notice_text':
    'This action will transfer all management permissions to the new owner. You will lose owner privileges for this group after the transfer.',
  'spaces.confirm_transfer': 'Confirm Transfer',
  'spaces.batch_mute': 'Batch Mute',
  'spaces.batch_mute_success': 'Successfully muted {count} rooms',
  'spaces.unmute': 'Unmute',
  'spaces.member_mute': 'Member Mute',
  'spaces.full_mute': 'Full Mute',

  // Room Detail
  'rooms.detail_title': 'Room Detail — {name}',
  'rooms.description': 'Description',
  'rooms.member_count': 'Members',
  'rooms.is_private': 'Private',
  'rooms.created_at': 'Created At',
  'rooms.message_history': 'Message History',
  'rooms.message_total': '({count} messages)',
  'rooms.deleted': 'Deleted',
  'rooms.image': '[Image]',
  'rooms.message_deleted': 'This message has been deleted',
  'rooms.image_message': 'Image message',
  'rooms.delete_message': 'Delete message',
  'rooms.no_messages': 'No messages',
  'rooms.system': 'System',
  'rooms.member_list': 'Member List — {name}',
  'rooms.joined_at': 'Joined on {date}',
  'rooms.unknown_user': 'Unknown User',
  'rooms.no_members': 'No members',
  'rooms.mute_title': 'Mute Room',
  'rooms.mute_desc': 'Set mute mode for {name}',
  'rooms.unmute_option': 'Unmute',
  'rooms.player_mute': 'Member Mute (admins can speak)',
  'rooms.full_mute': 'Full Mute',
  'rooms.delete_title': 'Delete Room',
  'rooms.delete_confirm':
    'Are you sure you want to delete {name}? This action is irreversible. All messages and member data will be permanently deleted.',
  'rooms.confirm_delete': 'Confirm Delete',
  'rooms.assign_admin_title': 'Assign Room Admin',
  'rooms.assign_admin': 'Assign Admin',
  'rooms.admin_must_be_member': 'Admin must be a space member',
  'rooms.assign_admin_desc': 'Assign admins for {name} (multi-select)',
  'rooms.current_admins': 'Current Admins',
  'rooms.not_assigned': 'Not assigned',
  'rooms.select_admins': 'Select Admins',
  'rooms.select_admin_placeholder': 'Select from space members',
  'rooms.selected_count': '({count} selected)',
  'rooms.no_selectable_members': 'No selectable members',
  'rooms.no_admins': 'No admins yet. Add from above.',
  'rooms.deselect_note': 'Deselecting all will remove all admins',
  'rooms.confirm_assign': 'Confirm Assign',
  'rooms.space_admin_title': 'Manage Space Admins',
  'rooms.space_admin_desc': 'Set admins for {name} (multi-select)',
  'rooms.current_admin_badge': 'Current Admin',
  'rooms.owner_note':
    'Space owner role cannot be changed. Deselecting all will remove all admins',
  'rooms.confirm_save': 'Confirm Save',
  'rooms.create_title': 'Create Room in {name}',
  'rooms.upload_avatar': 'Upload Avatar',
  'rooms.room_name': 'Room Name',
  'rooms.room_name_placeholder': 'e.g. Announcements',
  'rooms.desc_optional': 'Description (optional)',
  'rooms.desc_placeholder': 'What is this room about?',
  'rooms.set_announcement': 'Set as Announcement Channel',
  'rooms.set_private': 'Set as Private',
  'rooms.members': 'Members',
  'rooms.create_room': 'Create Room',
  'rooms.create_room_desc': 'Create a new room in "{name}"',

  // Space Settings
  'space_settings.title': 'Space Settings',
  'space_settings.avatar': 'Space Avatar',
  'space_settings.avatar_hint': 'Recommended: 512x512px, JPG/PNG',
  'space_settings.upload_avatar': 'Upload Avatar',
  'space_settings.description': 'Space Description',
  'space_settings.no_description': 'No description',
  'space_settings.space_type': 'Space Type',
  'space_settings.private_space': 'Private Space',
  'space_settings.private_desc': 'Requires invitation link or code to join',
  'space_settings.public_space': 'Public Space',
  'space_settings.public_desc': 'All users will join this space automatically',
  'space_settings.invitation_link': 'Invitation Link',
  'space_settings.invitation_desc':
    'Private spaces require this invitation link to join',
  'space_settings.no_link_placeholder': 'No invitation link, click to generate',
  'space_settings.base_url_warning':
    'Please configure the "Invitation Link Base URL" in Platform Settings → Feature Toggles first.',
  'space_settings.invitation_code': 'Code: {code}',
  'space_settings.generate_failed': 'Failed to generate invitation link',
  'space_settings.suffix_invalid':
    'Please enter 2-3 digits for the invite code suffix',
  'space_settings.regenerate': 'Regenerate',
  'space_settings.link_generated': 'Invitation link generated successfully',
  'space_settings.upload_avatar_failed': 'Failed to upload avatar',
  'space_settings.avatar_upload_success': 'Space avatar updated successfully',
  'space_settings.confirm_make_public':
    'Make this space public? All users will join this space automatically.',
  'space_settings.confirm_make_private':
    'Make this space private? Only users with an invitation link or code will be able to join.',

  // Report Management
  'reports.title': 'Report Management',
  'reports.subtitle': 'Review and handle user reports',
  'reports.pending': 'Pending',
  'reports.reviewing': 'Reviewing',
  'reports.resolved': 'Resolved',
  'reports.rejected': 'Rejected',
  'reports.search_placeholder': 'Search reporter, reported user, or group...',
  'reports.type': 'Report Info',
  'reports.reporter': 'Reporter',
  'reports.reported_user': 'Reported User',
  'reports.group': 'Group',
  'reports.reason': 'Reason',
  'reports.priority': 'Priority',
  'reports.time': 'Date',
  'reports.type_harassment': 'Harassment',
  'reports.type_spam': 'Spam',
  'reports.type_inappropriate': 'Inappropriate',
  'reports.type_violence': 'Violence',
  'reports.type_other': 'Other',
  // Report reason labels (from Flutter app)
  'reports.reason_bullying_harassment': 'Bullying, harassment, or abuse',
  'reports.reason_violent_content': 'Violent, hateful, or disturbing content',
  'reports.reason_suicide_self_harm': 'Suicide or self-harm',
  'reports.reason_restricted_items': 'Selling or promoting restricted items',
  'reports.reason_adult_content': 'Adult content',
  'reports.reason_scams_fraud': 'Scams, fraud, or false information',
  'reports.reason_other': 'Other reason',
  'reports.reason_threatening_nudes': 'Threatening to share my nude images',
  'reports.reason_sexual_exploitation': 'Appears to be sexual exploitation',
  'reports.reason_human_trafficking': 'Appears to be human trafficking',
  'reports.reason_bullying': 'Bullying or harassment',
  'reports.priority_low': 'Low',
  'reports.priority_medium': 'Medium',
  'reports.priority_high': 'High',
  'reports.priority_critical': 'Critical',
  'reports.view_detail': 'View Details',
  'reports.mark_reviewing': 'Mark as Reviewing',
  'reports.mark_in_progress': 'Mark as In Progress',
  'reports.view_profile': 'View Profile',
  'reports.warn_user': 'Warn User',
  'reports.send_warning_message': 'Send Warning Message to Reported User',
  'reports.ban_user': 'Ban User',
  'reports.suspend_user': 'Suspend User',
  'reports.reject_report': 'Reject Report',
  'reports.reject_title': 'Reject Report',
  'reports.reject_desc': 'Confirm rejecting the report against {name}?',
  'reports.reject_notice_title': 'Notice',
  'reports.reject_notice_text':
    'After rejection, this report will be marked as rejected. No action will be taken against the reported user.',
  'reports.reject_reason_label': 'Rejection Reason',
  'reports.reject_reason_placeholder': 'Enter rejection reason...',
  'reports.confirm_reject': 'Confirm Reject',
  'reports.no_reports': 'No reports',
  'reports.detail_title': 'Report Detail',
  'reports.detail_subtitle':
    'View full report information and handling options',
  'reports.report_type': 'Report Type',
  'reports.related_group': 'Related Group',
  'reports.report_reason': 'Report Reason',
  'reports.detail_description': 'Detailed Description',
  'reports.reported_content': 'Reported Content',
  'reports.submit_time': 'Submit Time',
  'reports.warn_title': 'Warn User',
  'reports.warn_desc': 'Issue a warning to user {name}',
  'reports.warn_info':
    'The warning will be recorded in the user profile. Multiple warnings may lead to account suspension.',
  'reports.warn_reason_label': 'Warning Reason',
  'reports.warn_reason_placeholder': 'Enter warning reason...',
  'reports.confirm_warn': 'Confirm Warning',
  'reports.ban_title': 'Ban User',
  'reports.ban_desc': 'Confirm banning user {name}?',
  'reports.ban_info':
    'After banning, this user will not be able to log in or use the platform. This action can be reversed in User Management.',
  'reports.ban_reason_label': 'Ban Reason',
  'reports.ban_reason_placeholder': 'Enter ban reason...',
  'reports.confirm_ban': 'Confirm Ban',
  'reports.evidence': 'Evidence Details',
  'reports.evidence_images': 'Evidence Images',
  'reports.report_history': 'Reported User History',
  'reports.reported_label': 'Reported',
  'reports.warning_record': 'Warning Record',
  'reports.in_location': 'In "{name}"',
  'reports.mute_user': 'Mute',
  'reports.mute_title': 'Mute User',
  'reports.mute_desc': 'Prevent user {name} from sending messages in the group',
  'reports.mute_info':
    'After muting, the user will not be able to send any messages or images in the group chat.',
  'reports.mute_duration': 'Mute Duration',
  'reports.mute_select_duration': 'Select mute duration',
  'reports.mute_1day': '1 Day',
  'reports.mute_3days': '3 Days',
  'reports.mute_1week': '1 Week',
  'reports.mute_1month': '1 Month',
  'reports.mute_permanent': 'Until unmuted',
  'reports.confirm_mute': 'Confirm Mute',

  // Admin Management
  'admin.title': 'Sub-account Management',
  'admin.subtitle': 'Manage admin accounts and permissions',
  'admin.search_placeholder': 'Search sub-account name, username, or email...',
  'admin.create_admin': '+ Add Admin',
  'admin.total_admins': 'Total Sub-accounts',
  'admin.active': 'Active',
  'admin.disabled': 'Disabled',
  'admin.admin_col': 'Sub-account',
  'admin.owner': 'Owner',
  'admin.admin_role': 'Admin',
  'admin.you': '(you)',
  'admin.current_account': 'Current account',
  'admin.edit': '✏️ Edit',
  'admin.disable': 'Disable',
  'admin.enable': 'Enable',
  'admin.transfer_ownership': 'Transfer Ownership',
  'admin.transfer_confirm':
    'Are you sure you want to transfer ownership to "{name}"? You will lose owner privileges.',
  'admin.transfer_failed': 'Transfer failed',
  'admin.create_title': 'Create Sub-account',
  'admin.unique_username': 'Unique username',
  'admin.min_9_chars': 'Min 9 characters',
  'admin.edit_title': 'Edit Sub-account: {name}',
  'admin.new_password': 'New Password (leave blank to keep)',

  // Admin Detail
  'admin.view_detail': 'View Detail',
  'admin.back_to_list': 'Back to Sub-account List',
  'admin.edit_profile': 'Edit Profile',
  'admin.change_password': 'Change Password',
  'admin.disable_account': 'Disable Account',
  'admin.delete_account': 'Delete Account',
  'admin.account_info': 'Account Info',
  'admin.activity_log': 'Activity Log',
  'admin.login_history': 'Login History',
  'admin.permission_count': 'Permissions',
  'admin.last_login': 'Last Login',
  'admin.department': 'Department',
  'admin.edit_permissions': 'Edit Permissions',
  'admin.edit_profile_title': 'Edit Sub-account Profile',
  'admin.edit_profile_desc': 'Modify sub-account basic information',
  'admin.change_password_title': 'Change Password',
  'admin.change_password_desc': 'Set new password for {name}',
  'admin.new_password_input': 'New Password',
  'admin.new_password_placeholder': 'Enter new password...',
  'admin.confirm_password': 'Confirm New Password',
  'admin.confirm_password_placeholder': 'Re-enter new password...',
  'admin.confirm_change': 'Confirm Change',
  'admin.passwords_mismatch': 'Passwords do not match',
  'admin.delete_title': 'Delete Sub-account',
  'admin.delete_confirm': "Confirm deleting sub-account {name}'s account?",
  'admin.delete_warning': 'Warning',
  'admin.delete_warning_text':
    'After deletion, this sub-account will not be able to log in to the backoffice system. This action is irreversible.',
  'admin.confirm_delete': 'Confirm Delete',
  'admin.edit_permissions_title': 'Edit Sub-account Permissions',
  'admin.edit_permissions_desc': "Modify {name}'s permission settings",
  'admin.admin_info': 'Sub-account Info',
  'admin.no_activity': 'No activity records',
  'admin.no_login_history': 'No login history',
  'admin.login_success': 'Success',
  'admin.login_failed': 'Failed',
  'admin.role_label': 'Role',
  'admin.upload_avatar': 'Upload Avatar',
  'admin.enable_account': 'Enable Account',

  // Platform Config
  'config.title': 'Platform Settings',
  'config.subtitle': 'Configure platform features and security settings',
  'config.customer_support': 'Customer Support',
  'config.support_email_placeholder': 'Enter support email address',
  'config.support_email_invalid': 'Please enter a valid email address',
  'config.qq_placeholder': 'Enter support QQ number',
  'config.wechat_placeholder': 'Enter support WeChat ID',
  'config.telegram_placeholder': 'Enter support Telegram account',
  'config.support_hint':
    'Users can contact the support team through the methods above',
  'config.app_download_links': 'APP Download Links',
  'config.ios_link_placeholder': 'Paste iOS download link',
  'config.android_link_placeholder': 'Paste Android download link',
  'config.mac_link_placeholder': 'Paste macOS download link',
  'config.windows_link_placeholder': 'Paste Windows download link',
  'config.download_page': 'Download App Page',
  'config.download_page_placeholder': 'Paste download page URL',
  'config.member_mobile_links': 'Member Mobile Links',
  'config.member_mobile_links_add': 'Add Link',
  'config.member_mobile_links_empty': 'No member mobile links configured',
  'config.member_mobile_links_display_name_placeholder': 'Enter display name',
  'config.member_mobile_links_url_placeholder': 'Enter member site URL',
  'config.security_verification': 'Security Verification',
  'config.enable_login_captcha': 'Enable Login Captcha',
  'config.enable_login_captcha_desc':
    'Require captcha verification during login to improve security',
  'config.sensitive_words': 'Sensitive Word Management',
  'config.sensitive_words_list': 'Sensitive Word List',
  'config.sensitive_words_placeholder':
    'Enter sensitive words, separated by commas',
  'config.sensitive_words_hint':
    'The system will automatically filter messages containing these words. Separate multiple words with commas.',
  'config.terms_and_license': 'Terms & License',
  'config.select_content_to_edit': 'Select content to edit',

  // My Account
  'account.title': 'My Account',
  'account.subtitle': 'Manage your personal information and account settings',
  'account.avatar': 'Avatar',
  'account.avatar_hint': 'Click the camera icon to upload a new avatar',
  'account.avatar_formats': 'Supports JPG, PNG format, max 5MB',
  'account.basic_info': 'Basic Information',
  'account.display_name': 'Display Name',
  'account.username': 'Username',
  'account.security': 'Security Settings',
  'account.login_password': 'Login Password',
  'account.password_hint':
    'Changing your password regularly improves account security',
  'account.change_password': 'Change Password',
  'account.error_name_required': 'Display name is required',
  'account.error_name_min': 'Display name must be at least 3 characters',
  'account.error_email_invalid': 'Please enter a valid email address',
  'account.error_mobile_invalid': 'Please enter a valid mobile number',
  'account.current_password': 'Current Password',
  'account.current_password_placeholder': 'Enter current password',
  'account.new_password': 'New Password',
  'account.new_password_placeholder': 'Enter new password',
  'account.confirm_password': 'Confirm New Password',
  'account.confirm_password_placeholder': 'Re-enter new password',
  'account.change_password_desc':
    'Enter your current password and new password. New password must be at least 9 characters and include uppercase, lowercase, number, and special character.',
  'account.password_min_length': 'Password must be at least 9 characters',
  'account.password_needs_lowercase':
    'Password must contain at least 1 lowercase letter',
  'account.password_needs_uppercase':
    'Password must contain at least 1 uppercase letter',
  'account.password_needs_number': 'Password must contain at least 1 number',
  'account.password_needs_special':
    'Password must contain at least 1 special character (@$!%*?&)',
  'account.passwords_mismatch': 'New passwords do not match',
  'account.error_current_password_required': 'Current password is required',
  'account.password_policy_hint':
    'Min 9 characters, with uppercase, lowercase, number, and special character (@$!%*?&)',
  'account.email': 'Email',
  'account.mobile': 'Mobile Number',
  'account.avatar_invalid_format': 'Only JPG and PNG formats are supported',
  'account.avatar_too_large': 'File size must not exceed 5MB',
  'account.avatar_updated': 'Avatar updated successfully',

  // Permissions
  'permissions.title': 'Permissions',
  'permissions.column': 'Permissions',
  'permissions.users': 'User Management',
  'permissions.users_desc': 'View, edit, delete users',
  'permissions.spaces': 'Space Management',
  'permissions.spaces_desc': 'Manage spaces and rooms',
  'permissions.reports': 'Report Management',
  'permissions.reports_desc': 'Handle user reports',
  'permissions.sensitive_words': 'Sensitive Words',
  'permissions.sensitive_words_desc':
    'Manage platform sensitive words and content filtering',
  'permissions.feedback': 'User Feedback',
  'permissions.feedback_desc': 'View and manage user feedback',
  'permissions.x_posts': 'Posts Management',
  'permissions.x_posts_desc': 'Manage content crawler, channels, and posts',
  'permissions.audit_logs': 'Audit Logs',
  'permissions.audit_logs_desc': 'View system operation records',
  'permissions.settings': 'Platform Settings',
  'permissions.settings_desc': 'Modify system configuration',
  'permissions.admins': 'Sub-account Management',
  'permissions.admins_desc': 'Manage other sub-accounts',
  'config.general': 'General',
  'config.security': 'Security',
  'config.notifications': 'Notifications',
  'config.features': 'Feature Toggles',
  'config.avatars': 'Avatars',
  'config.terms': 'Terms & Policies',
  'config.license': 'License',
  'config.platform_info': 'Platform Info',
  'config.platform_name': 'Platform Name',
  'config.platform_desc': 'Platform Description',
  'config.contact_phone': 'Contact Phone',
  'config.support_email': 'Support Email',
  'config.qq': 'QQ',
  'config.wechat': 'WeChat',
  'config.registration_settings': 'Registration Settings',
  'config.username_registration': 'Username Registration',
  'config.username_registration_desc':
    'Users register and login with username and password',
  'config.language_settings': 'Language Settings',
  'config.default_language': 'Default Language',
  'config.default_language_desc': 'Set the default display language',
  'config.simplified_chinese': '简体中文',
  'config.english': 'English',
  'config.data_management': 'Data Management',
  'config.data_backup': 'Data Backup',
  'config.last_backup': 'Last backup: 2024-03-27 02:00',
  'config.backup_now': 'Backup Now',
  'config.clear_cache': 'Clear Cache',
  'config.clear_cache_desc': 'Clear system cache to improve performance',
  'config.export_data': 'Export Data',
  'config.export_data_desc': 'Export all platform data',
  'config.export': 'Export',
  'config.security_policy': 'Security Policy',
  'config.two_factor': 'Two-Factor Authentication',
  'config.two_factor_desc':
    'Require admins to enable two-factor authentication',
  'config.login_captcha': 'Login Captcha',
  'config.login_captcha_desc': 'Require captcha verification during login',
  'config.ip_whitelist': 'IP Whitelist',
  'config.ip_whitelist_desc':
    'Only allow whitelisted IPs to access the admin panel',
  'config.session_timeout': 'Session Timeout (minutes)',
  'config.password_strength': 'Password Strength Requirements',
  'config.pwd_min_length': 'At least 8 characters',
  'config.pwd_upper_lower': 'Include upper and lowercase letters',
  'config.pwd_numbers': 'Include numbers',
  'config.pwd_special': 'Include special characters',
  'config.notification_events': 'Notification Events',
  'config.notif_new_user': 'New User Registration',
  'config.notif_report': 'User Report Submitted',
  'config.notif_group_create': 'Group Created',
  'config.notif_system_error': 'System Error',
  'config.notif_daily_report': 'Daily Data Report',
  'config.feature_control': 'Feature Settings',
  'config.requires_mobile_number': 'Requires mobile number to be enabled',
  'config.requires_email_enabled': 'Requires email to be enabled',
  'config.input_placeholder': 'Enter {field}',
  'config.frequency.5min': '5 minutes',
  'config.frequency.10min': '10 minutes',
  'config.frequency.15min': '15 minutes',
  'config.frequency.20min': '20 minutes',
  'config.frequency.30min': '30 minutes',
  'config.frequency.1hour': '1 hour',
  'config.frequency.2hours': '2 hours',
  'config.frequency.3hours': '3 hours',
  'config.frequency.4hours': '4 hours',
  'config.frequency.6hours': '6 hours',
  'config.frequency.8hours': '8 hours',
  'config.frequency.12hours': '12 hours',
  'config.frequency.24hours': '24 hours',
  'config.otp_method.sms': 'SMS OTP',
  'config.otp_method.email': 'Email OTP',
  'config.otp_method.off': 'Off',
  'config.allow_registration': 'User Registration',
  'config.allow_registration_desc': 'Allow new users to register',
  'config.allow_public_group': 'Public Group Creation',
  'config.allow_public_group_desc': 'Allow users to create public groups',
  'config.allow_private_group': 'Private Group Creation',
  'config.allow_private_group_desc': 'Allow users to create private groups',
  'config.allow_file_sharing': 'File Sharing',
  'config.allow_file_sharing_desc': 'Allow file sharing in rooms',
  'config.allow_voice_messages': 'Voice Messages',
  'config.allow_voice_messages_desc': 'Allow sending voice messages',
  'config.avatar_management': 'Predefined Avatar Management',
  'config.upload_avatar': '+ Upload Avatar',
  'config.no_avatars': 'No predefined avatars',
  'config.no_avatars_hint':
    'Manage predefined avatars available during user registration',
  'config.upload_avatar_hint': 'Click to upload new avatar',
  'config.upload_avatar_format': 'Supports JPG, PNG formats',
  'config.refresh_list': 'Refresh List',
  'config.confirm_delete_avatar':
    'Are you sure you want to delete this avatar?',
  'config.terms_title': 'Terms and Privacy Policy',
  'config.terms_placeholder': 'Enter terms and privacy policy content here...',
  'config.license_title': 'License',
  'config.license_placeholder': 'Enter license content here...',
  'config.last_updated': 'Last updated: {date}',

  // Platform Config Keys (from database)
  'platform_config.registration.requireCaptcha':
    'Require Captcha on Registration',
  'platform_config.registration.requireCaptcha_desc':
    'Require captcha verification during registration',
  'platform_config.registration.requireMobileNumber': 'Require Mobile Number',
  'platform_config.registration.requireMobileNumber_desc':
    'Require mobile number during registration',
  'platform_config.registration.requireOtp': 'Require SMS Verification',
  'platform_config.registration.requireOtp_desc':
    'Require SMS OTP verification during registration',
  'platform_config.registration.otpMethod': 'OTP Verification Method',
  'platform_config.registration.otpMethod_desc':
    'Choose verification method: SMS, Email, or Off',
  'platform_config.registration.requireEmail': 'Require Email Address',
  'platform_config.registration.requireEmail_desc':
    'Require email address during registration',
  'platform_config.registration.requireEmailVerification':
    'Require Email Verification',
  'platform_config.registration.requireEmailVerification_desc':
    'Require Email OTP verification during registration',
  'platform_config.security.loginCaptcha': 'Enable Login Captcha',
  'platform_config.security.loginCaptcha_desc':
    'Require captcha verification when users log in for enhanced security',
  'platform_config.features.maxFileSizeMB': 'Max File Size (MB)',
  'platform_config.features.maxFileSizeMB_desc':
    'Maximum upload file size in MB',
  'platform_config.features.maxGroupMembers': 'Max Group Members',
  'platform_config.features.maxGroupMembers_desc':
    'Maximum number of members per group',
  'platform_config.x_crawl_frequency_minutes': 'Crawl Frequency (minutes)',
  'platform_config.x_crawl_frequency_minutes_desc':
    'How often to fetch new posts from X channels (5–1440)',
  'platform_config.x_crawl_max_posts_per_channel':
    'Max Posts Per Channel Per Crawl',
  'platform_config.x_crawl_max_posts_per_channel_desc':
    'Maximum number of posts to fetch per channel each crawl cycle (1–20)',
  'platform_config.invitation.baseUrl':
    'Invitation Link Base URL (e.g. https://example.com/invite)',
  'platform_config.invitation.baseUrl_desc':
    'Base URL used for generating invitation links',
  'platform_config.jpush.app_key': 'JPush App Key',
  'platform_config.jpush.app_key_desc': 'JPush push notification app key',
  'platform_config.jpush.master_secret': 'JPush Master Secret',
  'platform_config.jpush.master_secret_desc':
    'JPush push notification master secret',

  // Audit Logs
  'audit.title': 'Audit Logs',
  'audit.subtitle': 'View system operation records and change history',
  'audit.admin': 'Admin',
  'audit.admin_id': 'Admin ID',
  'audit.all_modules': 'All Modules',
  'audit.all_actions': 'All Actions',
  'audit.search_placeholder': 'Search by admin username...',
  'audit.module': 'Module',
  'audit.start_date': 'Start Date',
  'audit.end_date': 'End Date',
  'audit.no_logs': 'No audit logs found',
  'audit.date_range_exceeded': 'Date range cannot exceed {days} days',
  'audit.date_range_invalid': 'Start date must be before end date',
  'audit.timestamp': 'Time',
  'audit.description': 'Description',
  'audit.details': 'Details',
  'audit.changes': 'Changes',
  'audit.field': 'Field',
  'audit.before': 'Before',
  'audit.after': 'After',
  'audit.deleted_values': 'Deleted Values',
  // Module names (matches sidebar navigation)
  'audit.module.user': 'User Management',
  'audit.module.space': 'Group Management',
  'audit.module.report': 'Report Management',
  'audit.module.feedback': 'Feedback',
  'audit.module.admin': 'Sub-account Management',
  'audit.module.settings': 'System Settings',
  'audit.module.x_posts': 'Content Management',
  'audit.module.unknown': 'Other',
  // Action descriptions
  'audit.action.CREATE_USER': 'Created user',
  'audit.action.UPDATE_USER': 'Updated user',
  'audit.action.BAN_USER': 'Banned user',
  'audit.action.UNBAN_USER': 'Unbanned user',
  'audit.action.MUTE_USER': 'Muted user',
  'audit.action.UNMUTE_USER': 'Unmuted user',
  'audit.action.DELETE_USER': 'Deleted user',
  'audit.action.CREATE_SPACE_OWNER': 'Created space owner',
  'audit.action.UPDATE_SPACE_OWNER': 'Updated space owner',
  'audit.action.ENABLE_SPACE_OWNER': 'Enabled space owner',
  'audit.action.DISABLE_SPACE_OWNER': 'Disabled space owner',
  'audit.action.CREATE_SPACE': 'Created space',
  'audit.action.UPDATE_SPACE': 'Updated space',
  'audit.action.UPDATE_SPACE_VERIFICATION': 'Updated space verification',
  'audit.action.REASSIGN_SPACE_OWNER': 'Reassigned space owner',
  'audit.action.DEACTIVATE_SPACE': 'Deactivated space',
  'audit.action.ACTIVATE_SPACE': 'Activated space',
  'audit.action.DELETE_SPACE': 'Deleted space',
  'audit.action.ADD_SPACE_MEMBERS': 'Added space members',
  'audit.action.REMOVE_SPACE_MEMBER': 'Removed space member',
  'audit.action.SET_SPACE_ADMINS': 'Set space admins',
  'audit.action.CREATE_ROOM': 'Created room',
  'audit.action.UPDATE_ROOM': 'Updated room',
  'audit.action.DELETE_ROOM': 'Deleted room',
  'audit.action.ADD_ROOM_MEMBERS': 'Added room members',
  'audit.action.REMOVE_ROOM_MEMBER': 'Removed room member',
  'audit.action.ASSIGN_ROOM_ADMINS': 'Assigned room admins',
  'audit.action.SET_ROOM_MUTE': 'Set room mute',
  'audit.action.DELETE_MESSAGE': 'Deleted message',
  'audit.action.GENERATE_INVITATION_CODES': 'Generated invitation codes',
  'audit.action.GENERATE_SPACE_INVITATION_LINK':
    'Generated space invitation link',
  'audit.action.UPDATE_INVITATION_BASE_URL': 'Updated invitation base URL',
  'audit.action.ADD_SENSITIVE_WORD': 'Added sensitive word',
  'audit.action.BATCH_UPLOAD_SENSITIVE_WORDS': 'Batch uploaded sensitive words',
  'audit.action.REMOVE_SENSITIVE_WORD': 'Removed sensitive word',
  'audit.action.REPLACE_PLATFORM_SENSITIVE_WORDS':
    'Replaced platform sensitive words',
  'audit.action.UPDATE_CONTENT': 'Updated content',
  'audit.action.UPDATE_PLATFORM_CONFIG': 'Updated platform config',
  'audit.action.SEND_NOTIFICATION': 'Sent notification',
  'audit.action.WARN_REPORTED_USER': 'Warned reported user',
  'audit.action.UPDATE_FEEDBACK_STATUS': 'Updated feedback status',
  'audit.action.ADD_FEEDBACK_REPLY': 'Added feedback reply',
  'audit.action.BACKOFFICE_ADMIN_CREATED': 'Created backoffice admin',
  'audit.action.BACKOFFICE_ADMIN_UPDATED': 'Updated backoffice admin',
  'audit.action.BACKOFFICE_OWNERSHIP_TRANSFERRED':
    'Transferred backoffice ownership',
  'audit.action.CREATE_CATEGORY': 'Created category',
  'audit.action.UPDATE_CATEGORY': 'Updated category',
  'audit.action.DELETE_CATEGORY': 'Deleted category',
  'audit.action.CONVERT_ROOM_TO_PRIVATE': 'Converted room to private',
  'audit.action.CONVERT_ROOM_TO_PUBLIC': 'Converted room to public',
  'audit.action.CREATE_X_POST': 'Created post',
  'audit.action.UPDATE_X_POST': 'Updated post',
  'audit.action.DELETE_X_POST': 'Deleted post',
  'audit.action.PUBLISH_X_POST': 'Published post',
  'audit.action.UNPUBLISH_X_POST': 'Unpublished post',
  'audit.action.TRIGGER_CRAWL': 'Triggered crawl',

  // Invitation Codes
  'invitation.base_url_title': '🔗 Invitation Link Base URL',
  'invitation.base_url_desc':
    'Set the base URL for invitation links. Generated links will use this URL as a prefix. e.g. https://example.com/invite',
  'invitation.current_base_url': 'Current base URL:',
  'invitation.current_link_title': '🔗 Current Invitation Link',
  'invitation.invitation_link_label': 'Invitation link:',
  'invitation.no_base_url_warning':
    '⚠️ Base URL not configured. Please set the invitation link base URL above to generate full links.',
  'invitation.no_active_code': 'No active invitation code. Generate one below.',
  'invitation.generate_new': '🔄 Generate New Code',
  'invitation.generate_revokes': '(Revokes Current)',
  'invitation.generate_warning':
    'Generating a new code will revoke all existing unused codes for this space.',
  'invitation.confirm_generate':
    'This will revoke all existing unused codes for this space. Continue?',
  'invitation.code_history': 'Code History',
  'invitation.usage_logs': 'Usage Logs',
  'invitation.hide_usage_logs': 'Hide Usage Logs',
  'invitation.view_usage_logs': 'View Usage Logs',
  'invitation.filter': 'Filter:',
  'invitation.active': 'Active',
  'invitation.code': 'Code',
  'invitation.link': 'Invitation Link',
  'invitation.status_revoked': 'Revoked',
  'invitation.status_used': 'Used',
  'invitation.status_active': 'Active',
  'invitation.used_by': 'Used By',
  'invitation.used_at': 'Used At',
  'invitation.created': 'Created',
  'invitation.no_codes': 'No codes found',
  'invitation.no_base_url': 'Base URL not configured',
  'invitation.copy_code': 'Code',
  'invitation.copy_link': 'Link',
  'invitation.no_usage_logs': 'No usage logs found',
  'invitation.title': 'Invitation Code Management',
  'invitation.space_owner': 'Space Owner',
  'invitation.space': 'Space',
  'invitation.no_spaces': 'No spaces',
  'invitation.active_codes': 'Active Codes',
  'invitation.used': 'Used',
  'invitation.revoked': 'Revoked',
  'invitation.total_generated': 'Total Generated',
  'invitation.copied': '✓ Copied',
  'invitation.copy': '📋 Copy Code',

  // Feedback Management
  'nav.feedback': 'User Feedback',

  // Posts
  'nav.x_posts': 'Content Management',

  'feedback.title': 'User Feedback',
  'feedback.subtitle': 'View and manage user feedback and suggestions',
  'feedback.pending': 'Pending',
  'feedback.processing': 'Processing',
  'feedback.resolved': 'Resolved',
  'feedback.closed': 'Closed',
  'feedback.total': 'Total Feedback',
  'feedback.search_placeholder': 'Search feedback title, content or user...',
  'feedback.all_status': 'All Status',
  'feedback.all_types': 'All Types',
  'feedback.type_feature_request': 'Feature Request',
  'feedback.type_bug_report': 'Bug Report',
  'feedback.type_suggestion': 'Suggestion',
  'feedback.type_other': 'Other',
  'feedback.feedback_title': 'Feedback Title',
  'feedback.type': 'Type',
  'feedback.status': 'Status',
  'feedback.submitted_at': 'Submitted',
  'feedback.back_to_list': 'Back to Feedback List',
  'feedback.reply_count': 'Replies ({count})',
  'feedback.no_replies': 'No replies yet',
  'feedback.reply_placeholder': 'Enter reply content...',
  'feedback.internal_note': 'Internal Note (not visible to user)',
  'feedback.send_reply': 'Send Reply',
  'feedback.reply_sent': 'Reply sent successfully',
  'feedback.upload_image': 'Upload Image',
  'feedback.upload': 'Upload',
  'feedback.management': 'Management',
  'feedback.save_changes': 'Save Changes',
  'feedback.info': 'Feedback Info',
  'feedback.feedback_id': 'Feedback ID',
  'feedback.submitted_time': 'Submitted',
  'feedback.last_updated': 'Last Updated',
  'feedback.screenshots': 'Screenshots',
  'feedback.user_info': 'User Info',
  'feedback.device': 'Device',
  'feedback.version': 'Version',
  'feedback.no_feedback': 'No feedback found',
  'feedback.admin_badge': 'Admin',

  // Chatroom Detail
  'chatroom.back_to_space': 'Back to Room Detail',
  'chatroom.total_members': 'Total Members',
  'chatroom.total_messages': 'Total Messages',
  'chatroom.admin_count': 'Admins',
  'chatroom.created_date': 'Created Date',
  'chatroom.created_on': 'Created on {date}',
  'chatroom.view_messages': 'View Messages',
  'chatroom.edit_room': 'Edit Room',
  'chatroom.edit_room_desc': 'Modify room basic information',
  'chatroom.room_name': 'Room Name',
  'chatroom.room_name_placeholder': 'Enter room name',
  'chatroom.description_placeholder': 'Enter room description',
  'chatroom.view_all_members': 'View All Members',
  'chatroom.settings': 'Room Settings',
  'chatroom.room_avatar': 'Room Avatar',
  'chatroom.description': 'Room Description',
  'chatroom.no_description': 'No description',
  'chatroom.room_type': 'Room Type',
  'chatroom.public_room': 'Public Room',
  'chatroom.public_room_desc':
    'Visible and joinable by all members in the space',
  'chatroom.private_room': 'Private Room',
  'chatroom.private_room_desc': 'Only invited members can join and view',
  'chatroom.mute_settings': 'Mute Settings',
  'chatroom.allow_member_chat': 'Allow Member Chat',
  'chatroom.allow_member_chat_desc': 'All members can send messages',
  'chatroom.announcement_settings': 'Announcement Settings',
  'chatroom.set_as_announcement': 'Set as Announcement Group',
  'chatroom.set_as_announcement_desc':
    'Only admins can send messages, members can only view',
  'chatroom.announcement_enabled': 'Announcement Group Enabled',
  'chatroom.announcement_enabled_desc': 'Only admins can send messages',
  'chatroom.only_admins_can_send': 'Only admins can send messages',
  'chatroom.all_members_can_send': 'All members can send messages',
  'chatroom.confirm_set_announcement':
    'Set this room as an announcement group? Only admins will be able to send messages.',
  'chatroom.confirm_unset_announcement':
    'Remove announcement group setting? All members will be able to send messages.',
  'chatroom.save_all_settings': 'Save All Settings',
  'chatroom.confirm_allow_chat':
    'Allow all members to send messages in this room?',
  'chatroom.confirm_mute_chat':
    'Mute all members in this room? Only admins will be able to send messages.',
  'chatroom.avatar_upload_success': 'Room avatar updated successfully',
  'chatroom.avatar_upload_failed': 'Failed to upload room avatar',
  'chatroom.room_admins': 'Room Admins',
  'chatroom.view_profile': 'View Profile',
  'chatroom.remove_admin': 'Remove Admin',
  'chatroom.confirm_remove_admin': 'Remove {name} from admin role?',
  'chatroom.admin_name': 'Admin',
  'chatroom.role': 'Role',
  'chatroom.assigned_date': 'Assigned Date',
  'chatroom.room_members': 'Room Members',
  'chatroom.view_all': 'View All',
  'chatroom.member_name': 'Member',
  'chatroom.join_date': 'Join Date',
  'chatroom.message_count': 'Messages',
  'chatroom.role_admin': 'Admin',
  'chatroom.role_owner': 'Space Owner',
  'chatroom.role_space_admin': 'Space Admin',
  'chatroom.role_member': 'Member',
  'chatroom.back_to_detail': 'Back to Room Detail',
  'chatroom.add_member_title': 'Add Room Members',
  'chatroom.add_member_desc': 'Search and add users to room "{name}"',
  'chatroom.member_list_title': 'Member List',
  'chatroom.total_count': '{count} members total',
  'chatroom.active_members': 'Active Members',
  'chatroom.search_member_placeholder': 'Search member name, username or ID...',
  'chatroom.filter_all': 'All Members',
  'chatroom.filter_admin': 'Admins',
  'chatroom.filter_member': 'Members',
  'chatroom.last_active': 'Last Active',
  'chatroom.confirm_convert_private':
    'Convert this room to private? Only invited members will be able to access it.',
  'chatroom.confirm_convert_public':
    'Convert this room to public? All space members will be able to access it.',
  'chatroom.converting_visibility': 'Converting...',
  'chatroom.owner_dm': 'Owner DM',
  'chatroom.friend_dm': 'Friend DM',
  'chatroom.locked': 'Locked',

  // Chat History
  'chathistory.back_to_detail': 'Back to Room Detail',
  'chathistory.total_messages': 'Total Messages',
  'chathistory.reported_messages': 'Flagged Messages',
  'chathistory.blocked_count': 'Muted Members',
  'chathistory.active_members': 'Active Members',
  'chathistory.members_label': 'members',
  'chathistory.messages_label': 'messages',
  'chathistory.search_placeholder': 'Search message content or sender...',
  'chathistory.filter_all': 'All Messages',
  'chathistory.filter_normal': 'Normal',
  'chathistory.filter_reported': 'Flagged',
  'chathistory.flagged': 'Flagged',
  'chathistory.delete_confirm':
    'Are you sure you want to delete this message? This action is irreversible.',
  'chathistory.message_deleted': 'Message deleted',
  'chathistory.attachment': 'Attachment',
  'chathistory.view_image': 'View image',

  // Form Validation
  'validation.username_min_length': 'Username must be at least 6 characters',
  'validation.username_max_length': 'Username must not exceed 50 characters',
  'validation.username_alphanumeric':
    'Username must contain only letters and numbers',
  'validation.display_name_min_length':
    'Display name must be at least 6 characters',
  'validation.admin_display_name_min_length':
    'Display name must be at least 3 characters',
  'validation.display_name_max_length':
    'Display name must not exceed 50 characters',
  'validation.password_min_length': 'Password must be at least 9 characters',
  'validation.password_needs_lowercase':
    'Password must contain at least 1 lowercase letter',
  'validation.password_needs_uppercase':
    'Password must contain at least 1 uppercase letter',
  'validation.password_needs_number': 'Password must contain at least 1 number',
  'validation.password_needs_special':
    'Password must contain at least 1 special character (@$!%*?&)',
  'validation.mobile_format': 'Mobile number must be 6-15 digits',
  'validation.mobile_invalid_for_country':
    'Invalid phone number for selected country',
  'validation.country_code_format': 'Invalid country code',
  'validation.contains_masked_content':
    'Cannot save masked content. Please enter the actual value.',
  'validation.email_invalid': 'Please enter a valid email address',
  'validation.email_required': 'Email is required',
  'validation.permissions_required': 'At least one permission must be assigned',
  'validation.space_name_min_length':
    'Channel name must be at least 3 characters',
  'validation.space_name_max_length':
    'Channel name must not exceed 100 characters',
  'validation.description_min_length':
    'Description must be at least 10 characters',
  'validation.description_max_length':
    'Description must not exceed 1000 characters',
  'validation.visibility_required': 'Please select a channel type',
  'validation.owner_required': 'Please select a channel owner',
  'validation.url_invalid': 'Please enter a valid URL',
  'validation.password_hint':
    'Min 9 characters, must include uppercase, lowercase, number, and special character (@$!%*?&)',

  // Toast Messages
  'toast.user_created': 'User created successfully',
  'toast.user_updated': 'User updated successfully',
  'toast.user_deleted': 'User deleted successfully',
  'toast.user_banned': 'User banned successfully',
  'toast.user_unbanned': 'User unbanned successfully',
  'toast.user_muted': 'User muted successfully',
  'toast.user_unmuted': 'User unmuted successfully',
  'toast.user_create_failed': 'Failed to create user',
  'toast.user_update_failed': 'Failed to update user',
  'toast.user_delete_failed': 'Failed to delete user',
  'toast.user_ban_failed': 'Failed to ban user',
  'toast.user_unban_failed': 'Failed to unban user',
  'toast.user_mute_failed': 'Failed to mute user',
  'toast.user_unmute_failed': 'Failed to unmute user',
  'toast.space_created': 'Channel created successfully',
  'toast.space_updated': 'Channel updated successfully',
  'toast.space_status_updated': 'Channel status updated',
  'toast.space_deleted': 'Space deleted successfully',
  'toast.space_delete_failed': 'Failed to delete space',
  'toast.space_admins_updated': 'Admins updated successfully',
  'toast.ownership_transferred': 'Ownership transferred successfully',
  'toast.room_created': 'Room created successfully',
  'toast.room_mute_updated': 'Room mute settings updated',
  'toast.room_deleted': 'Room deleted successfully',
  'toast.room_admins_updated': 'Room admins updated',
  'toast.members_added': 'Members added successfully',
  'toast.space_create_failed': 'Failed to create channel',
  'toast.space_update_failed': 'Failed to update channel',
  'toast.space_status_update_failed': 'Failed to update channel status',
  'toast.space_admins_update_failed': 'Failed to update admins',
  'toast.ownership_transfer_failed': 'Failed to transfer ownership',
  'toast.room_create_failed': 'Failed to create room',
  'toast.room_mute_update_failed': 'Failed to update mute settings',
  'toast.room_delete_failed': 'Failed to delete room',
  'toast.room_admins_update_failed': 'Failed to update room admins',
  'toast.members_add_failed': 'Failed to add members',
  'toast.admin_created': 'Admin created successfully',
  'toast.admin_updated': 'Admin updated successfully',
  'toast.admin_deleted': 'Admin deleted successfully',
  'toast.admin_create_failed': 'Failed to create admin',
  'toast.admin_update_failed': 'Failed to update admin',
  'toast.admin_delete_failed': 'Failed to delete admin',
  'toast.room_updated': 'Room updated successfully',
  'toast.room_update_failed': 'Failed to update room',
  'toast.member_removed': 'Member removed successfully',
  'toast.member_remove_failed': 'Failed to remove member',
  'toast.message_deleted': 'Message deleted successfully',
  'toast.message_delete_failed': 'Failed to delete message',
  'toast.report_updated': 'Report status updated',
  'toast.user_warned': 'Warning sent to user',

  // Common (additional)
  'common.upload_failed': 'Upload failed',

  // Posts Management
  'x_posts.title': 'Posts Management',
  'x_posts.subtitle': '{total} posts collected from {channels} channels',
  'x_posts.create_post': '+ Create Post',
  'x_posts.fetch_posts': 'Fetch Posts',
  'x_posts.fetching_posts': 'Fetching...',
  'x_posts.search_placeholder': 'Search posts...',
  'x_posts.all_topics': 'All topics',
  'x_posts.no_posts':
    'No posts found. Adjust your filters or wait for the next crawl.',
  'x_posts.add_username_placeholder': 'Add @username',
  'x_posts.add_btn': 'Add',
  'x_posts.original_text_placeholder': 'Original text (English)',
  'x_posts.translation_placeholder': 'Translated text (Chinese) — optional',
  'x_posts.content_placeholder': 'Post content',
  'x_posts.content_label': 'Content',
  'x_posts.create_btn': 'Create',
  'x_posts.creating': 'Creating...',
  'x_posts.cancel': 'Cancel',
  'x_posts.summary_label': 'Summary / Description',
  'x_posts.summary_placeholder': 'Summary or translated description',
  'x_posts.topics_label': 'Topics',
  'x_posts.upload': 'Upload',
  'x_posts.regenerate': 'Regenerate',
  'x_posts.save_title': 'Save',
  'x_posts.cancel_title': 'Cancel',
  'x_posts.edit_title': 'Edit summary & topics',
  'x_posts.publish_title': 'Publish',
  'x_posts.unpublish_title': 'Unpublish',
  'x_posts.delete_title': 'Delete',
  'x_posts.delete_confirm': 'Delete this post?',
  'x_posts.topic_required': 'Please select a category',
  'x_posts.content_required': 'Post must have text or at least one image',
  'x_posts.remove_channel_confirm': 'Remove @{username}?',
  'x_posts.fetch_channel_title': 'Fetch @{username}',
  'x_posts.all_status': 'All status',
  'x_posts.status.posted': 'Posted',
  'x_posts.status.held': 'Held',
  'x_posts.hold_reason.sensitive': 'Sensitive',
  'x_posts.hold_reason.error': 'Unreviewed',
  'x_posts.hold_reason.unposted': 'Unposted',
  'x_posts.topic.politics': 'Politics',
  'x_posts.topic.economy': 'Economy',
  'x_posts.topic.tech': 'Tech',
  'x_posts.topic.sports': 'Sports',
  'x_posts.topic.entertainment': 'Entertainment',
  'x_posts.topic.other': 'Other',
  'x_posts.toast.post_deleted': 'Post deleted',
  'x_posts.toast.delete_failed': 'Failed to delete',
  'x_posts.toast.published': 'Post published',
  'x_posts.toast.unpublished': 'Post unpublished',
  'x_posts.toast.toggle_failed': 'Failed to toggle publish',
  'x_posts.toast.post_updated': 'Post updated',
  'x_posts.toast.update_failed': 'Failed to update',
  'x_posts.toast.post_created': 'Post created',
  'x_posts.toast.create_failed': 'Failed to create post',
  'x_posts.toast.crawl_queued': 'Crawl job queued — posts will appear shortly',
  'x_posts.toast.channel_crawl_queued': 'Fetching channel posts...',
  'x_posts.toast.crawl_failed': 'Failed to trigger crawl',
  'x_posts.toast.channel_added': '@{username} added',
  'x_posts.toast.channel_add_failed': 'Failed to add channel',
  'x_posts.toast.channel_removed': '@{username} removed',
  'x_posts.toast.channel_remove_failed': 'Failed to remove channel',
  'x_posts.toast.upload_failed': 'Failed to upload {name}',
  'x_posts.view_original': 'View original',
  'x_posts.toast.classify_queued': 'Classify job queued',
  'x_posts.toast.classify_failed': 'Failed to classify post',
  'x_posts.toast.generate_image_queued': 'Generate image job queued',
  'x_posts.toast.generate_image_failed': 'Failed to generate image',
  'x_posts.toast.generate_thumbnails_success':
    'Thumbnails generated: {{processed}} processed, {{failed}} failed',
  'x_posts.toast.generate_thumbnails_failed': 'Failed to generate thumbnails',
  'x_posts.toast.translate_images_queued': 'Translate images job queued',
  'x_posts.toast.translate_images_failed': 'Failed to translate images',
  'x_posts.toast.jobs_cancelled': 'All pending jobs cancelled',
  'x_posts.toast.cancel_failed': 'Failed to cancel jobs',
  'x_posts.classify_title': 'Classify post',
  'x_posts.generate_image_title': 'Generate image',
  'x_posts.generate_thumbnails': 'Generate Thumbnails',
  'x_posts.translate_images_title': 'Translate images',
  'x_posts.cancel_jobs': 'Cancel',
  'x_posts.sync_followings': 'Sync Channels',
  'x_posts.syncing_followings': 'Syncing...',
  'x_posts.toast.sync_followings_success': 'Channels synced successfully',
  'x_posts.toast.sync_followings_failed': 'Failed to sync channels',
};

export default en;
